import { Box } from '@mui/material';

const SeperatorDate = () => {
  return (
    <Box
      component="span"
      sx={{
        width: '6px',
        height: '4px',
        backgroundColor: 'global01.400',
        borderRadius: '2px',
        display: 'inline-block',
        marginX: 1,
      }}
    />
  );
};
export default SeperatorDate;
